import visa from "../assets/cardIcons/visa.svg";
import defaultCard from "../assets/bank-providers/default.svg";
import master from "../assets/cardIcons/master.svg";
import mir from "../assets/cardIcons/mir.svg";
import { IOffer } from "../store/payment/types";

const VISA__NUM = "4";
const MASTER__CARD__NUM = "5";
const MIR__NUM = ["2200", "2201", "2202", "2203", "2204", "9"];

export const getPaymentType = (cardNumber: string) => {
  if (cardNumber) {
    if (cardNumber[0] === VISA__NUM) {
      return visa;
    }
    if (cardNumber[0] === MASTER__CARD__NUM) {
      return master;
    }
    if (MIR__NUM.includes(String(cardNumber).slice(0, 4))) {
      return mir;
    }

    if (MIR__NUM.includes(String(cardNumber).slice(0, 1))) {
      return mir;
    }
  }
  return defaultCard;
};
